import createUrlHash from '../../../functions/create-url-hash'
import EventBus from '../../../functions/event-bus'
import getUrlHash from '../../../functions/get-url-hash'

class Alphabet {
  constructor (button) {
    this.button = button
    this.letter = button.dataset.alphabet
    this.group = document.querySelector(`#alphabet-group-${this.letter}`)

    this.id = this.group.id
    this.isActive = false

    this.button.addEventListener('click', () => {
      this.select()
    })

    // Pre-select alphabet if it's referenced by hash
    if (this.id === getUrlHash().alphabet) {
      this.select()
    }

    // Deselect alphabet when another one is selected
    EventBus.subscribe('alphabet', id => {
      if (id !== this.id) {
        this.deselect()
      }
    })
  }

  select (addUrlHash = true) {
    this.button.classList.add('is-active')
    this.group.classList.add('is-active')

    this.isActive = true

    EventBus.publish('alphabet', this.id)

    if (addUrlHash) {
      const state = { alphabet: this.id }
      history.replaceState(state, null, createUrlHash(state))
    }
  }

  deselect () {
    this.button.classList.remove('is-active')
    this.group.classList.remove('is-active')

    this.isActive = false
  }
}

const buttons = document.querySelectorAll('.js-alphabet-button')
const alphabets = []

buttons.forEach(button => alphabets.push(new Alphabet(button)))

// Select first alphabet if there's no alphabet already selected by URL hash

let selectedAlphabet
const alphabetHash = getUrlHash().alphabet

if (alphabetHash) {
  selectedAlphabet = document.querySelector(`#${alphabetHash}`)
}

if (!selectedAlphabet && alphabets.length) {
  alphabets[0].select(false)
}

// Listen for hash changes (for example by a link)
// Open the corresponding alphabet if the ID matches

window.addEventListener('hashchange', () => {
  alphabets.forEach(alphabet => {
    if (alphabet.id === getUrlHash().alphabet) {
      alphabet.select()
    }
  })
})
